import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderComponent } from './structure/header/header.component';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from './structure/footer/footer.component';
import { ScrollTopComponent } from './structure/scroll-top/scroll-top.component';

@Component({
  selector: 'nikkan-corporate-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [HeaderComponent, RouterOutlet, FooterComponent, ScrollTopComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  title = '株式会社日刊プロスポーツ新聞社';
}
